package `fun`.adaptive.cookbook

import `fun`.adaptive.resource.image.Images
import `fun`.adaptive.resource.image.ImageResource
import `fun`.adaptive.resource.image.ImageResourceSet

private object commonMainImage0 {

    val small_logo by lazy { init_small_logo() }

    val background by lazy { init_background() }

    val favicon by lazy { init_favicon() }

    val logo by lazy { init_logo() }

}

val Images.small_logo
    get() = commonMainImage0.small_logo

private fun init_small_logo() =
    ImageResourceSet(
        name = "small_logo",
        ImageResource("/fun.adaptive.cookbook/images/small_logo.png", setOf())
    )

val Images.background
    get() = commonMainImage0.background

private fun init_background() =
    ImageResourceSet(
        name = "background",
        ImageResource("/fun.adaptive.cookbook/images/background.jpg", setOf())
    )

val Images.favicon
    get() = commonMainImage0.favicon

private fun init_favicon() =
    ImageResourceSet(
        name = "favicon",
        ImageResource("/fun.adaptive.cookbook/images/favicon.png", setOf())
    )

val Images.logo
    get() = commonMainImage0.logo

private fun init_logo() =
    ImageResourceSet(
        name = "logo",
        ImageResource("/fun.adaptive.cookbook/images/logo.png", setOf())
    )